import React from "react";
import { Typography } from "@material-ui/core";
import useStyles from "./ReservationsTitleStyles";

interface ReservationsTitleProps {
  name?: string;
}

export const ReservationsTitle = ({ name }: ReservationsTitleProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography className={classes.name}>{name ? `Hola, ${name}` : "Hola"}</Typography>
      <Typography className={classes.description}>
        Escaneá el QR del ingresante y validá si tiene reserva para hoy.
      </Typography>
    </div>
  );
};
